// @ts-ignore - idiomorph doesn't have TypeScript definitions
import { Idiomorph } from "idiomorph";
import ApplicationController from "../application_controller";
import { templatizeHtml, traverseElements } from "../../helpers/dom";

function processFrames(html: string) {
  const template = templatizeHtml(html);
  traverseElements(template, (ele: HTMLElement) => {
    const name = ele.dataset.frame;
    if (name) {
      const targetFrames = document.querySelectorAll(`[data-frame="${name}"]`);
      if (targetFrames.length) {
        targetFrames.forEach((frame) => {
          // use default morphStyle: "outerHTML" to avoid tooltips getting stuck or jumping around
          // this behavior can be noticed when Drafts are in "working" state and we do polling and display a tooltip in the frame
          Idiomorph.morph(frame, ele);
        });
      }
      // avoid complexities with processing nested frames
      return true;
    }
    return false;
  });
}

export default class MorphController extends ApplicationController {
  process(event: StimulusEvent) {
    const { html } = event.detail;
    processFrames(html);
  }

  morph(event: StimulusEvent) {
    event.stopPropagation();
    const { html } = event.detail;
    const template = templatizeHtml(html);
    // use morphStyle: "innerHTML" to keep the "data-frame" element so that we are able to re-render the same frame over and over
    // this can be noticed in Marketing/pricing Addons table
    // eventually the morphStyle could be removed once our backend will return the full HTML for the frame
    Idiomorph.morph(event.currentTarget, template.content, { morphStyle: "innerHTML" });
  }
}
